import { render, staticRenderFns } from "./ModalTurnOff.vue?vue&type=template&id=61ac9578&"
import script from "./ModalTurnOff.vue?vue&type=script&lang=js&"
export * from "./ModalTurnOff.vue?vue&type=script&lang=js&"
import style0 from "./ModalTurnOff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports